function bingoGen(writer){

    var cardOptions = {
        "inoue": 
        [
            "Yellow gets snubbed",
            "Someone dies",
            "Villain arc",
            "Bury your gays",
            "Bonkers mid-season arc",
            "Love triangle(s)",
            "Unintentional sexual tension",
            "Awful couples",
            "Secret nonhuman protagonist",
            "Memory loss",
            "Low-effort rehabilitation arc",
            "Obvious toy marketing",
            "Evil queer-coded monster",
            "Flashbacks",
            "Banger music",
            "Hot monster ally",
            "Time travel",
            "Not explaining major plot points outside of supplemental material",
            "Misogyny",
            "Goroawase",
            "Christian aesthetics",
            "Kenji Matsuda",
            "Complicated parent-child feelings",
            "Angst",
            "Characters not sharing information",
            "Henshin device changes hands",
            "Evil little boy",
            "Wife trauma",
            "Mistaken identity",
            "Character thrown into water",
            "Malewife"
        ], 
        "takahashi":
        [
            "Kino action sequence",
            "Secondary villain turn",
            "Dead character comes back to life",
            "Game/competition arc(s)",
            "Intense suffering",
            "Dads",
            "Selling toys",
            "Character who becomes/becomes like one of the monsters",
            "\"Mission\"",
            "Copious amounts of English",
            "Jobber lady",
            "Collar grab",
            "Rider named after mythology",
            "\"Daybreak\"",
            "Evil rider final boss",
            "The evil riders use a different kind of belt",
            "Banger music",
            "Berserk form",
            "Femdom character",
            "Early villain becomes comedy character",
            "Dead parents",
            "Heated drama between men",
            "Really slow until second arc",
            "Evil genius",
            "Evil corporation"
        ]
    }

    var board = [[],[],[],[],[]]

    var shuffledOptions = cardOptions[writer];
    shuffledOptions.sort(function(a, b){return 0.5 - Math.random()});

    for(var i=0; i<5; i++){
        for(var j=0; j<5; j++){
            board[i][j] = shuffledOptions.pop();
        }
    }


    if(writer == "takahashi"){
        board[2][2] = "Too many characters (FREE)"
    }
    else {
        board[2][2] = "Extremely hateable rival character (FREE)"
    }
    console.log(board)
    return(board);
}

export default bingoGen;